<template>
  <div class="exception-form">
    <el-form :inline="true" :model="formInline" label-position="left" class="demo-form-inline" @keydown.native.enter.prevent="onSubmit">
      <el-form-item label="登记时间">
        <el-date-picker
          v-model="createDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="timeChange"
        />
      </el-form-item>
      <el-form-item :label="codeLabel">
        <el-input v-model="formInline.bizCode" :placeholder="codePlaceholder" maxlength="128" />
      </el-form-item>
      <el-form-item label="发注书名">
        <el-input v-model="formInline.purchaseBook" placeholder="请输入发注书名" maxlength="255" />
      </el-form-item>
      <el-form-item label="登记人">
        <el-input v-model="formInline.registerName" placeholder="请输入登记人" maxlength="50" />
      </el-form-item>
      <el-form-item label="需回复人">
        <el-select v-model="formInline.replyUserMobile" placeholder="全部" clearable>
          <el-option
            v-for="item in replyUserOptions"
            :key="item.mobile"
            :label="item.userName"
            :value="item.mobile"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formInline.status" placeholder="全部">
          <el-option v-for="item in statusOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { EXCEPTION_TYPE, STATUS_OPTIONS } from "../data";

export default {
  name: "InterForm",
  props: {
    // 当前异常类型
    exceptionType: {
      type: Number,
      required: true,
    },
    // 需回复人，页面从接口拉取后传入
    replyUserOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      // 日期范围控件值
      createDate: [],
      // 查询条件
      formInline: {
        bizCode: "",
        purchaseBook: "",
        registerName: "",
        replyUserMobile: "",
        status: "",
        createTimeStart: undefined,
        createTimeEnd: undefined,
      },
      // 状态下拉
      statusOptions: STATUS_OPTIONS,
    };
  },
  computed: {
    // SKU / 运单号标签
    codeLabel: function () {
      return this.exceptionType === EXCEPTION_TYPE.PARCEL ? "运单号" : "SKU";
    },
    // SKU / 运单号占位
    codePlaceholder: function () {
      return this.exceptionType === EXCEPTION_TYPE.PARCEL ? "请输入运单号" : "请输入SKU";
    },
  },
  created() {
    // 进入页面默认查询当前 Tab
    this.$emit("querySubmit", this.buildParams());
  },
  methods: {
    // 日期范围变更
    timeChange: function (val) {
      if (!val || val.length !== 2) {
        this.formInline.createTimeStart = undefined;
        this.formInline.createTimeEnd = undefined;
        return;
      }
      this.formInline.createTimeStart = val[0];
      this.formInline.createTimeEnd = val[1];
    },
    // 按手机号取需回复人
    getReplyUser: function (mobile) {
      if (!mobile) {
        return undefined;
      }
      return this.replyUserOptions.find((item) => item.mobile === mobile);
    },
    // 组装查询参数
    buildParams: function () {
      const replyUser = this.getReplyUser(this.formInline.replyUserMobile);
      return {
        bizCode: this.formInline.bizCode || undefined,
        purchaseBook: this.formInline.purchaseBook || undefined,
        registerName: this.formInline.registerName || undefined,
        replyUserMobile: this.formInline.replyUserMobile || undefined,
        replyUserId: replyUser ? replyUser.userId : undefined,
        replyUserName: replyUser ? replyUser.userName : undefined,
        status: this.formInline.status === "" ? undefined : this.formInline.status,
        createTimeStart: this.formInline.createTimeStart,
        createTimeEnd: this.formInline.createTimeEnd,
      };
    },
    // 查询
    onSubmit: function () {
      this.$emit("querySubmit", this.buildParams());
    },
    // 重置当前 Tab 筛选
    restSubmit: function () {
      this.createDate = [];
      this.formInline = {
        bizCode: "",
        purchaseBook: "",
        registerName: "",
        replyUserMobile: "",
        status: "",
        createTimeStart: undefined,
        createTimeEnd: undefined,
      };
      this.onSubmit();
    },
    // Tab 切换时清空并查询
    resetAndQuery: function () {
      this.restSubmit();
    },
  },
};
</script>

<style scoped>
.exception-form {
  padding: 16px 0 0;
  flex: 1;
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
</style>
